import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || '/api/v1';

export const api = axios.create({ baseURL, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gd_carburanti_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.config?.url !== '/admin/login') {
      localStorage.removeItem('gd_carburanti_token');
      localStorage.removeItem('gd_carburanti_user');
    }
    return Promise.reject(error);
  }
);
